import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './AuthProvider'

export function ProtectedRoute() {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return <main className="center-page">Carregando sessão…</main>
  }
  if (!user) {
    return <Navigate to="/entrar" replace state={{ from: location }} />
  }
  return <Outlet />
}

